module.exports = {"id":"s4-q2","text":"Do you need to log in to see content?","multiselect":false,"options":[{"id":"s4-q2-a1","text":"Yes","capability":2,"access":2,"next":"s4-q3","focusarea":[0,3,2,0,0]},{"id":"s4-q2-a2","text":"No","next":"s4-q3","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s4-q2.json
// module id = 906
// module chunks = 41